import React, { useContext, useState } from 'react';
import Login from "./Login";
import Activation from "./Activation";
import Regi from "./Regi";
import AppContext from "../../AppContext";
import { RegiWrap } from "../utils/Utils";
import { Lang, ModalService } from "../../services/Services";

const LoginScreen = ({ initialHelpView, forceHelp }) => {
	const context = useContext(AppContext);
	const [isLogin, isLoginUpd] = useState(!!initialHelpView);
	const [helpView, helpViewUpd] = useState(initialHelpView || null);

	if (context.UserService.user && !forceHelp) { return null; }

	const switchToRegister = (code) => {
		if (code) {
			context.UserService.activationCode = code;
		}
		if (context.UserService.user) {
			context.UserService.logout();
		}
		isLoginUpd(false);
		helpViewUpd(null);
		ModalService.openBlueCover(<Regi />);
	};

	return (
		<RegiWrap hasImg tabs={
			<>
			<li className={!isLogin ? "active" : ""} onClick={() => { isLoginUpd(false); helpViewUpd(null); }} >{Lang.activate_login.butten_register}</li>
			<li className={isLogin ? "active" : ""} onClick={() => { isLoginUpd(true); helpViewUpd(null); }}  >{Lang.activate_login.butten_login}</li>
			</>
		}		>
			{isLogin ? <Login key={helpView || "login"} initialHelpView={helpView} onSwitchToRegister={switchToRegister} /> : <Activation isLoginUpd={isLoginUpd} />}
		</RegiWrap>	
	);

}

export default LoginScreen;
